module.exports = __webpack_public_path__ + "static/w1-b494ad9d7524b40057c9799ef1f1c2df.jpg";